import { render, staticRenderFns } from "./WorkforceEdit.vue?vue&type=template&id=1d049f70&"
import script from "./WorkforceEdit.vue?vue&type=script&lang=js&"
export * from "./WorkforceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports